export const userConstants = {
    SET_ORGANIZATION: 'SET_ORGANIZATION',
    SET_BANNER_LICENSE_REDEEMED: 'SET_BANNER_LICENSE_REDEEMED',
    // SHOW_FILE_VIEWER_TUTORIAL: 'SHOW_FILE_VIEWER_TUTORIAL',
};